export enum CustomDynamicFilterType {
  dateTimeRange = 'date-time-range',
}
